<div>
  <form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2">
    <div class="row">
      <div class="col-md-12">
        <div class="row">
          <!-- Datum -->
          <div class="col-lg-2">
            <div class="form-group row">
              <div class="col-md-12 col-12">
                <yt-fw-date-picker-popup formControlName="Datum" name="txtDatDok" [Label]="'KURSDOKUMENT.DATUM.SINGULAR'"
                  [ngClass]="{'is-invalid': submitted && fc.Datum.invalid}" #autofocus
                  (OnDateSelected)="onDatumChange($event)">
                </yt-fw-date-picker-popup>
                <div class="form-error" *ngIf="submitted && fc.Datum.invalid">
                  <span *ngFor="let validation of errorMessages.Datum">
                    <span class="error-message" *ngIf="fc.Datum.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        
      <!-- Opis -->
      <div class="col-lg-10 col-12">
        <div class="form-group row">
          <div class="col-md-12">
            <yt-input [Type]="'text'" [Label]="'KURSDOKUMENT.OPIS.SINGULAR'" formControlName="Opis" [ngClass]="{'is-invalid': submitted && fc.Opis.invalid}">
            </yt-input>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
    <div class="row">
      <div class="col-md-12">
        <yt-kurs-dokument-stavka-update-container #baseInlineContainer 
          [DetailModelData]="modelData.MainList.DetailList[0]"
          [ParentPropertyName]="'KursDokumentID'" 
          [ParentPropertyValue]="Item.ID"
          [Parameters]="TransferParameters">
        </yt-kurs-dokument-stavka-update-container>
      </div>
    </div>
  </form>
</div>